<template>
	<div class="container">
		<div class="form_box footer_box">
			<div class="input_box">
				<div class="tit">First name</div>
				<input v-model="firstVal" :class="isClick && !firstVal ? 'error' : ''" />
				<div v-show="isClick && !firstVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="tit">Last name</div>
				<input v-model="lastVal" :class="isClick && !lastVal ? 'error' : ''" />
				<div v-show="isClick && !lastVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="" style="color: #0B318F;">Organization</div>
				<input v-model="organizationVal" />
			</div>
			<div class="input_box">
				<div class="" style="color: #0B318F;">Title</div>
				<input v-model="titleVal" />
			</div>
			<div class="input_box">
				<div class="tit">Email</div>
				<input v-model="emailVal" :class="isClick && !emailVal ? 'error' : ''" />
				<div v-show="isClick && !emailVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="" style="color: #0B318F;">Phone Number</div>
				<input v-model="phoneVal" />
			</div>
			<div class="input_box">
				<div class="" style="color: #0B318F;">{{ title }}</div>
				<textarea v-model="helpVal" class="" style="height: 80px;line-height: 20px;"></textarea>
			</div>
			<div class="input_box">
				<div class="tit">How did you hear about us?</div>
				<select v-model="aboutVal" :class="isClick && !aboutVal ? 'error' : ''">
					<option value="Google Search">Google Search</option>
					<option value="Linkedin">Linkedin</option>
					<option value="Press Article">Press Article</option>
					<option value="Referral">Referral</option>
					<option value="Email">Email</option>
					<option value="Other">Other</option>
				</select>
			</div>
			<div class="input_box">
				<div class="" style="color: #0B318F;">Products you want to know</div>
				<textarea v-model="products" class="" style="height: 80px;line-height: 20px;"></textarea>
			</div>
			<div v-show="isClick && !aboutVal" class="error_tit">Please select an option from the dropdown menu.</div>
			<div v-show="isClick && !lastVal && !firstVal && !emailVal && !aboutVal" class="tips_box">
				<div class="error">Please complete all required fields.</div>
			</div>
			<div class="btn_box" @click="subClick">{{ btnTitle }}</div>
		</div>
	</div>
</template>

<script>
import { formSubmit } from '@/api/public';
export default {
	props: ["leixing", "titleText"],
	components:{
		//
	},
	data() {
		return {
			isSubmitting: false,
			emailVal: '',
			firstVal: '',
			lastVal: '',
			organizationVal: '',
			titleVal: '',
			phoneVal: '',
			helpVal: '',
			aboutVal: '',
			products: '',
			isClick: false,
			type: this.leixing,
			title: 'How can we help you today?',
			btnTitle: this.titleText,
			formType: 'Contact Us',
		}
	},
	created(){
		let that = this;
		if(that.type) {
			that.title = 'What would you like to discuss at '+ that.type +'?';
			that.formType = that.type;
		}
		if(that.titleText) {
			that.formType = that.btnTitle;
		}else {
			that.btnTitle = 'Subscribe';
		}
		if(that.$route.query.products) {
			that.products = that.$route.query.products.split('-')[0] + '(' + that.$route.query.products.split('-')[1] + ')';
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		subClick() {
			if (this.isSubmitting) return;
			let that = this;
			that.isClick = true;
			if(that.emailVal && that.firstVal && that.lastVal && that.aboutVal) {
				that.$toast.loading({
					forbidClick: true,
				});
				that.isSubmitting = true;
				formSubmit({
					first_name: that.firstVal,
					last_name: that.lastVal,
					organization: that.organizationVal,
					title: that.titleVal,
					email: that.emailVal,
					phone_number: that.phoneVal,
					content: that.helpVal,
					source: that.aboutVal,
					type: that.formType,
					product_name: that.products
				}).then(res => {
					that.$toast.clear();
					that.$toast('Your form has been successfully submitted, thank you!');
					that.emailVal = '';
					that.firstVal = '';
					that.lastVal = '';
					that.organizationVal = '';
					that.titleVal = '';
					that.phoneVal = '';
					that.helpVal = '';
					that.aboutVal = '';
					that.products = '';
					that.isClick = false;
				}).catch(() => {
					// The request interceptor displays the error; keep the form values for retry.
				}).then(() => {
					that.isSubmitting = false;
				});
			}
		},
	}
}
</script>

<style scoped>
.footer_box .input_box .tit::after{
	content: '*';
	color: #ff0000;
}
.footer_box .input_box .tit{
	color: #0B318F;
}
.footer_box .input_box input, .footer_box .input_box textarea, .footer_box .input_box select{
	width: 100%;
	background-color: #f5f8fa;
	color: #33475b;
	height: 42px;
	line-height: 21px;
	border: 1px solid #cbd6e2;
	padding: 10px;
}
.footer_box .input_box input.error{
	border-color: #c87872;
}
.footer_box .input_box textarea.error{
	border-color: #c87872;
}
.footer_box .input_box select.error{
	border-color: #c87872;
}
.footer_box .tips_box{
	margin-top: 8px;
}
.footer_box .tips_box .error{
	font-size: 14px;
	font-family: helvetica;
	color: #f2545b;
}
.footer_box .error_tit{
	color: #f2545b;
	font-size: 14px;
}
.footer_box .input_box_father{
	display: flex;
}
.footer_box .input_box{
	flex: 1;
	padding-bottom: 14px;
}
.footer_box .input_box_father .input_box:last-child{
	margin-left: 15px;
}
.footer_box .input_box_father .input_box:first-child{
	margin-right: 15px;
}
.footer_box .btn_box{
	display: inline-block;
	margin-top: 40px;
	padding: 14px 30px;
	text-align: center;
	background-color: #0B318F;
	cursor: pointer;
	color: #ffffff;
}
</style>
